<template>
    <article :class="userDetailsClass">
        <div class="user-details-card__info">
            <div class="user-details-card__avatar">
                <common-user-avatar :user="user" :type="type" size="user-menu"></common-user-avatar>
            </div>

            <div>
                <p v-if="topText" class="user-details-card__dark">
                    {{ topText }}
                </p>

                <p class="user-details-card__name">
                    <common-patient-name v-if="isPatient" :patient="user"></common-patient-name>
                    <common-user-name v-else :user="user"></common-user-name>
                </p>

                <p v-if="bottomText">
                    {{ bottomText }}
                </p>

                <p v-if="bottomText2">
                    {{ bottomText2 }}
                </p>

                <slot></slot>
            </div>
        </div>

        <template>
            <div v-if="showEmail || showPhone" :class="contactClass">
                <common-icon-info v-if="showEmail && user.email" :href="`mailto:${user.email}`" icon="email" size="medium">
                    {{ user.email }}
                </common-icon-info>

                <common-icon-info v-if="showPhone && user.phone" class="user-details-card__dark" icon="phone" size="medium">
                    {{ countryCode }} {{ user.phone }}
                </common-icon-info>

                <common-icon-info v-if="showPhone && user.mobilePhone" class="user-details-card__dark" icon="phone" size="medium">
                    {{ countryCode }} {{ user.mobilePhone }}
                </common-icon-info>
            </div>
        </template>
    </article>
</template>

<script>
    export default {
        props: {
            user: { type: Object, required: true },
            isPatient: { type: Boolean, default: false },
            topText: { type: String, default: null },
            bottomText: { type: String, default: null },
            bottomText2: { type: String, default: null },
            size: { type: String, default: 'medium' },
            showEmail: { type: Boolean, default: false },
            showPhone: { type: Boolean, default: false },
            alignContactDetails: { type: String, default: 'left' },
            type: { type: String, default: 'primary' },
        },

        data() {
            return {
                countryCode: '+1',
            }
        },

        computed: {
            userDetailsClass() {
                return {
                    'user-details-card': true,
                    [`user-details-card--size-${this.size}`]: true,
                }
            },

            contactClass() {
                return {
                    [`user-details-card__contact--size-${this.size}`]: true,
                    [`user-details-card__contact--align-${this.alignContactDetails}`]: true,
                }
            },
        },
    }
</script>
